
import React from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { BottomGradient, CreatorContent, CreatorTestemonyContainer, CreatorTestemonyContent, TestemonyCard, TestemonyCardContent } from './engagementDrop.creatorTestimony.styles';

interface CreatorTestemony {
  title: string;
  creatorImage: IGatsbyImageData;
  card: {
    description: string;
    creatorIdentification: string[];
  }
}

const CreatorTestemony = ({ title, creatorImage, card }: CreatorTestemony): JSX.Element => {
  return (
    <CreatorTestemonyContainer>
      <CreatorTestemonyContent>
        <CreatorContent>
          <Heading
            text={title}
            size="5.25rem"
            sizeSubLg="5rem"
            sizeSm="1.8rem"
            lineHeight="5rem"
            align="left"
            color="#FF00FF"
          />
          <GatsbyImage image={creatorImage} alt="creator image" />
        </CreatorContent>
        <TestemonyCard>
          <TestemonyCardContent>
            <Paragraph
              text={card.description}
              size="3.4rem"
              sizeLg="2.8rem"
              sizeSubLg="2.1rem"
              sizeSm="1.56rem"
              align="left"
              color="#ffffff"
              weight="light"
            />
            <div>
              {
                card.creatorIdentification.map((text, index) => (
                  <Heading
                    key={index}
                    text={text}
                    size="2.1rem"
                    sizeLg="1.7rem"
                    sizeSm="1.1rem"
                    align="left"
                    color="#ffffff"
                  />
                ))
              }
            </div>
          </TestemonyCardContent>
        </TestemonyCard>
      </CreatorTestemonyContent>
      <BottomGradient />
    </CreatorTestemonyContainer>
  )
}

export default CreatorTestemony;
